module.exports = __webpack_public_path__ + "img/gallery8.a0299901.jpg";